// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"NoPermissionBoundary_tooltip__1XGQm"};